import { useContext } from "react";

import {
  ModalContext,
  ModalContextProps,
  ModalRenderer,
} from "../components/modal/ModalContextProvider";

export type DispatchProps<P> = keyof Omit<P, "handleClose"> extends never
  ? void
  : Omit<P, "handleClose">;

function useModalDispatch<P>(
  component: ModalRenderer<P>,
  contextProps?: ModalContextProps,
): (props: DispatchProps<P>) => void;
function useModalDispatch(
  component: undefined,
  contextProps?: ModalContextProps,
): undefined;
function useModalDispatch<P>(
  component: ModalRenderer<P> | undefined,
  contextProps?: ModalContextProps,
): (props: DispatchProps<P>) => void | undefined;
function useModalDispatch<P>(
  component: ModalRenderer<P> | undefined,
  contextProps?: ModalContextProps,
) {
  const [setModal] = useContext(ModalContext) as ModalContext<P>;

  if (!component) {
    return undefined;
  }

  const dispatcher = (componentProps: DispatchProps<P>) => {
    setModal([component, componentProps, contextProps]);
  };

  return dispatcher;
}

export default useModalDispatch;
